export default __webpack_public_path__ + "static/media/MDI - send.101dbbdc.svg";